import { PrimaryLinkButton } from 'apps/wrapper/src/components/shared/buttons/buttons.styles';
import { useEventBus } from 'apps/wrapper/src/hooks/use-event-bus';
import { FC } from 'react';
import { LabeledSection } from '../labeled-section/labeled-section';
import { AiTranscriptSectionSkeleton } from './ai-transcript-section.skeleton';

export interface AiTranscriptSectionProps {
  isLoading: boolean;
  caseId?: string | null;
  patientId?: number | null;
}

export const AiTranscriptSection: FC<AiTranscriptSectionProps> = (props) => {
  const { isLoading, caseId, patientId } = props;
  const { publish } = useEventBus();

  const handleViewTransciptClick = () => {
    if (!caseId) return;

    publish({
      messageType: 'milaDialog',
      data: {
        type: 'view-case',
        caseId,
        patientId: patientId || undefined
      }
    });
  };

  if (isLoading) return <AiTranscriptSectionSkeleton />;

  if (!caseId) return null;

  return (
    <LabeledSection label="AI Transcript">
      <PrimaryLinkButton
        variant="text"
        onClick={handleViewTransciptClick}
        sx={{ justifyContent: 'flex-start', marginTop: '10px' }}
        disableRipple
      >
        View transcript
      </PrimaryLinkButton>
    </LabeledSection>
  );
};
